// Libs
import PropTypes from 'prop-types';

/**
 * Bar outline background component
 * @param root0
 * @param root0.bgProps
 * @param root0.barRadius
 * @param root0.trackEndXByIndexRef
 * @returns {JSX} BarOutlineBackground
 */
function BarOutlineBackground({ bgProps, barRadius, trackEndXByIndexRef }) {
    const { x = 0, y = 0, width = 0, height = 0, payload, index } = bgProps;
    const color = payload?.fill || '#000000';

    if (index !== undefined && index !== null && trackEndXByIndexRef) {
        trackEndXByIndexRef.current[index] = x + width;
    }
    return (
        <rect
            x={x}
            y={y}
            width={width}
            height={height}
            rx={barRadius}
            ry={barRadius}
            fill='#ffffff'
            stroke={color}
            strokeWidth={1}
        />
    );
}

BarOutlineBackground.propTypes = {
    bgProps: PropTypes.object.isRequired,
    trackEndXByIndexRef: PropTypes.object.isRequired,
    barRadius: PropTypes.number
};

export default BarOutlineBackground;